export default "/assets/webpack-assets/GT-Walsheim-Pro-Bold.6c64da3a4390c90130f1a7d35a956f16.ttf";